import { render, staticRenderFns } from "./ListProche.vue?vue&type=template&id=fe47b732&"
import script from "./ListProche.vue?vue&type=script&lang=js&"
export * from "./ListProche.vue?vue&type=script&lang=js&"
import style0 from "./ListProche.vue?vue&type=style&index=0&id=fe47b732&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports